(() => {
  if (window.framarAdventReady) return;
  window.framarAdventReady = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.adventInitialized === 'true') return;
    root.dataset.adventInitialized = 'true';

    const intro = root.querySelector('[data-advent-intro]');
    const hero = root.querySelector('#advent-hero');
    const video = root.querySelector('[data-advent-video]');
    const videoToggle = root.querySelector('[data-advent-video-toggle]');
    const videoFallback = root.querySelector('[data-advent-video-fallback]');
    const snow = root.querySelector('[data-advent-snow]');
    let visible = false;
    let userPaused = false;
    let userStarted = false;
    let opening = false;
    let warmingIntroVideo = false;

    if (intro) document.body.classList.add('advent-intro-open');

    if (snow && !reducedMotion.matches) {
      const context = snow.getContext('2d');
      const flakes = Array.from({ length: 80 }, () => ({
        x: Math.random(),
        y: Math.random(),
        radius: 1 + Math.random() * 2.5,
        speed: 0.25 + Math.random() * 0.75,
        drift: Math.random() * 0.4 - 0.2
      }));
      let width = 0;
      let height = 0;
      let previousFrame = 0;

      const resizeSnow = () => {
        const scale = Math.min(window.devicePixelRatio || 1, 2);
        width = window.innerWidth;
        height = window.innerHeight;
        snow.width = Math.round(width * scale);
        snow.height = Math.round(height * scale);
        context.setTransform(scale, 0, 0, scale, 0, 0);
      };

      const drawSnow = (time) => {
        window.requestAnimationFrame(drawSnow);
        if (document.hidden || time - previousFrame < 32) return;
        previousFrame = time;
        context.clearRect(0, 0, width, height);
        context.fillStyle = 'rgba(255, 255, 255, .8)';
        context.beginPath();
        flakes.forEach((flake) => {
          const x = flake.x * width;
          const y = flake.y * height;
          context.moveTo(x + flake.radius, y);
          context.arc(x, y, flake.radius, 0, Math.PI * 2);
          flake.y += flake.speed / height;
          flake.x += flake.drift / width;
          if (flake.y > 1) { flake.y = 0; flake.x = Math.random(); }
          if (flake.x < 0) flake.x = 1;
          if (flake.x > 1) flake.x = 0;
        });
        context.fill();
      };

      resizeSnow();
      window.addEventListener('resize', resizeSnow, { passive: true });
      window.requestAnimationFrame(drawSnow);
    }

    function updateToggle() {
      if (!videoToggle || !video) return;
      const playing = !video.paused;
      videoToggle.textContent = playing ? 'Pause video' : 'Play video';
      videoToggle.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
    }

    function showVideoFallback() {
      if (videoFallback) videoFallback.hidden = false;
      updateToggle();
    }

    function updatePlayback() {
      if (!video) return;
      const introOpen = intro && !intro.hidden;
      const mayPlay = !document.hidden && !userPaused &&
        ((warmingIntroVideo && !reducedMotion.matches) ||
          (visible && !introOpen && (!reducedMotion.matches || userStarted)));
      if (mayPlay) {
        video.play().catch(showVideoFallback);
      } else {
        video.pause();
      }
      updateToggle();
    }

    if (intro) {
      intro.querySelectorAll('[data-advent-open]').forEach((control) => {
        control.addEventListener('click', (event) => {
          event.preventDefault();
          if (opening) return;
          opening = true;
          const skip = control.classList.contains('lp-advent__skip');
          if (!skip && !reducedMotion.matches) intro.classList.add('is-opening');
          if (video && !skip && !reducedMotion.matches) {
            // Start the muted video behind the letter while its reveal plays.
            warmingIntroVideo = true;
            updatePlayback();
          }
          window.setTimeout(() => {
            warmingIntroVideo = false;
            intro.hidden = true;
            document.body.classList.remove('advent-intro-open');
            window.scrollTo({ top: 0, behavior: 'auto' });
            hero.querySelector('a')?.focus({ preventScroll: true });
            if (video && video.readyState >= 1) video.currentTime = 0;
            updatePlayback();
          }, skip || reducedMotion.matches ? 0 : 1400);
        });
      });
    }

    if (video && videoToggle) {
      videoToggle.hidden = false;
      video.addEventListener('play', updateToggle);
      video.addEventListener('playing', () => {
        if (videoFallback) videoFallback.hidden = true;
        updateToggle();
      });
      video.addEventListener('pause', showVideoFallback);
      videoToggle.addEventListener('click', () => {
        if (video.paused) {
          userStarted = true;
          userPaused = false;
          video.play().catch(showVideoFallback);
        } else {
          userPaused = true;
          video.pause();
        }
        updateToggle();
      });
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        updatePlayback();
      }, { threshold: 0.2 });
      observer.observe(hero);
      reducedMotion.addEventListener('change', updatePlayback);
      document.addEventListener('visibilitychange', updatePlayback);
    }
  }

  function initAll(container = document) {
    container.querySelectorAll('[data-advent-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
